import { useApiQuery } from '../useApiQuery'

export const useGetResultsSociogram = (termId) => {
  const query = useApiQuery(
    ['sociogram-results', `termId: ${termId}`],
    'sociogram',
    `/results?termId=${termId}`,
    { enabled: !!termId }
  )

  return {
    isLoadingResultsSociogram: query.isLoading,
    isFetchingResultsSociogram: query.isFetching,
    organizationResults: query.data ?? null,
    errorResultsSociogram: query.isError ? query.error : null,
    getResultsSociogram: query.refetch
  }
}
